<template>
    <div class="all-wrapper solid-bg-all">
        <div class="layout-w">
            <div class="content-w">
                <div class="top-bar">
                    <div class="logo-w">
                        <router-link :to="{ name: 'home' }" class="logo">
                            <img alt="" src="/images/logo.png">
                        </router-link>
                    </div>
                    <div class="top-menu-controls">
                        <div class="logged-user-w">
                            <div class="logged-user-i">
                                <div class="avatar-w">
                                    <img alt="" :src="avatar">
                                </div>
                                <div class="person-name">
                                    {{ personName }}
                                </div>
                                <div class="logged-user-menu color-style-bright">
                                    <div class="logged-user-avatar-info">
                                        <div class="avatar-w">
                                            <img alt="" :src="avatar">
                                        </div>
                                        <div class="logged-user-info-w">
                                            <div class="logged-user-name">
                                                {{ personName }}
                                            </div>
                                            <div class="logged-user-role" v-if="lastLogin.loginTime != ''">
                                                Last: {{ lastLogin.loginTime }}
                                            </div>
                                        </div>
                                    </div>
                                    <ul>
                                        <li>
                                            <a href="javascript:void(0)" @click="openMyAccount">
                                                <i class="os-icon os-icon-user-male-circle2"></i><span>My Account</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)" @click="openChangePassword">
                                                <i class="os-icon os-icon-lock"></i><span>Change Password</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0)" @click="showModal('logoutConfirm')">
                                                <i class="os-icon os-icon-signs-11"></i><span>Logout</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="feedback-btn">
                            <i @click="showFeebackPanel" class="os-icon os-icon-mail-12"></i>
                        </div>
                    </div>
                </div>
                <router-view v-if="isReady"></router-view>
                <div class="application-footer">&copy; 2021-{{ new Date().getFullYear() }} Green Business Certification Inc. All Rights Reserved.</div>
            </div>
        </div>
        <slideout-panel></slideout-panel>
        <b-modal ref="logoutConfirm" id="logoutConfirm"
            modal-class="onboarding-modal"
            centered no-close-on-backdrop no-close-on-esc lazy hide-header-close hide-header hide-footer>
            <logout-confirm></logout-confirm>
        </b-modal>
    </div>
</template>
<script>
import $ from 'jquery'
import datetime from '@/mixins/datetime'
import LogoutConfirm from '@/components/LogoutConfirm.vue'

export default {
    components: {
        LogoutConfirm
    },
    
    mixins: [datetime],
    
    data() {
        return {
            isReady: false,
            tokenChecked: false,
            personName: '',
            avatar: '',
            lastLogin: {},
            feedbackPanel: null
        }
    },
    
    computed: {
        getFullScreenLoaderClass() {
            return (window.innerWidth/2)-225
        }
    },
    
    mounted() {
        this.toggleBodyClass('addClass', 'with-content-panel')
        this.toggleBodyClass('addClass', 'full-screen')
        
        this.avatar = this.peer.user.avatar()
        
        this.personName = this.peer.user.getInfo()
        this.personName = this.personName.firstName+' '+this.personName.lastName
        
        let lastLogin = this.peer.user.getInfo().lastLogin
        
        if(lastLogin) {
            lastLogin = $.extend(true, {}, lastLogin)
            lastLogin.loginTime = this.convertAndDisplay(lastLogin.loginTime)
            this.lastLogin = lastLogin
        }
    },
    
    destroyed() {
        this.toggleBodyClass('removeClass', 'with-content-panel')
        this.toggleBodyClass('removeClass', 'full-screen')
    },
    
    methods: {
        showModal(id) {
            this.$refs[id].show()
        },
        
        generateStyleDef() {
            return `
            .peer-processing .el-loading-spinner {
                margin-left: ${this.getFullScreenLoaderClass}px !important;
            }`
        },
        
        applyStyle(styleDef) {
            let style = document.createElement('style')
            style.type = 'text/css'
            document.head.appendChild(style)
            style.innerHTML = styleDef
        },
        
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body
            
            if(addRemoveClass === 'addClass')
                el.classList.add(className)
            else
                el.classList.remove(className)
        },
        
        openMyAccount() {
            window.open(this.peer.user.getInfo().accountUrl)
        },
        
        openChangePassword() {
            let url = 'accounts.usgbc.org/change-password?redirect_uri='+encodeURIComponent(document.location.href)
            let env = this.$store.state.api.forcedEnv.toLowerCase()
            
            if(env !== 'prd')
                url = env+'-'+url
            
            url = 'https://'+url
            
            document.location.href = url
        },
        
        showFeebackPanel() {
            this.feedbackPanel = this.$showPanel({
                component: 'feedback',
                openOn: 'right',
                width: '400px',
                disableBgClick: true
            })
        },
        
        hideFeedbackPanel() {
            this.feedbackPanel.hide()
        },
        
        bindOAuthClient() {
            if(typeof platformApi !== 'object') {
                setTimeout(() => {
                    this.bindOAuthClient()
                }, 500)
            }
            else if(!platformApi.monitorKey) {
                this.peer.user.redirectToLogin()
            }
            else if(!platformApi.tokenChecked) {
                setTimeout(() => {
                    this.bindOAuthClient()
                }, 500)
            }
            else {
                this.tokenChecked = true
                
                platformApi.onProfileUpdated((obj) => {
                    this.peer.user.reFetch().done(() => {
                        obj.ack = true
                        
                        this.avatar = this.peer.user.avatar()
                        
                        this.personName = this.peer.user.getInfo()
                        this.personName = this.personName.firstName+' '+this.personName.lastName
                    }).fail((r) => {
                        if(this.peer.user.isTokenInvalid(r.data))
                            this.peer.user.redirectToLogin()
                    })
                })
                
                platformApi.onExternalLogout(() => {
                    this.peer.misc.blockScreen('Your session ended externally outside of this browser tab. Please wait while we redirect to the login page.')
                    setTimeout(() => {
                        this.peer.user.redirectToLogin()
                    }, 2000)
                })
            }
        }
    },
    
    created() {
        let styleDef = this.generateStyleDef()
        this.applyStyle(styleDef)
        
        this.peer.common.maintenanceSettings(
            (this.$route.query.__allowMe && this.$route.query.__allowMe === '1')
        ).then((r) => {
            if(r.maintenance === 2) {
                this.$router.push({
                    name: 'maintenance'
                })
            }
            else {
                this.peer.lists.bootApp().done(() => {
                    this.isReady = true
                })
            }
        })
        
        this.bindOAuthClient()
    }
}
</script>

<style scoped>
.feedback-btn {
    border-left: 1px dashed #c8c7c7;
    padding-left: 10px;
    margin-top: 10px;
}
.feedback-btn i {
    font-size: 25px;
    color: #6f6c6c;
    cursor: pointer;
}
</style>
